




<form #f="ngForm" class="form-group" role="form" enctype="multipart/form-data">
    <div class="row">
        <div class="col-lg-6 col-md-12 col-md-6 col-sm-12">
            <div class="form-group ">
                <label class="control-label" for="id">Employee Id</label>
                <input [(ngModel)]="id" class="form-control" type="text" id="id" name="id" readonly>
            </div>
            <div class="form-group">
                <label class="control-label" for="name">Employee Name</label>
                <input [(ngModel)]="name" required minlength="3" type="text" id="name" name="name" class="form-control" placeholder="Enter Employee name" />
            </div>
            <div class="form-group">
                <label class="control-label" for="departmentId">Department</label>
                <select [(ngModel)]="departmentId" required class="form-control" id="departmentId" name="departmentId"> <option disabled>-- Select Department --</option> <option class="active" *ngFor="let item of departmentsList" [value]="item.id">{{item.name}}</option> </select>
            </div>
            <div class="form-group">
                <label class="control-label" for="name">Date of Joining</label>
                <input [(ngModel)]="dateOfJoining" required #date class="form-control" type="date" name="dateOfJoining" />
                <div class="alert alert-info">{{dateOfJoining | date: 'fullDate' }}</div>
            </div>
        </div>
        <div class="text-center">
            <div class="col-lg-6 col-md-12 col-md-6 col-sm-12">
                <div class="form-group">
                    <div>
                        <input type="image" [src]="url" alt="Your photo no dey database" class="img-thumbnail card-img figure-img img-thumbnail img-fluid" [class.img-circle]="isImageCircle" width="200" height="200" />
                        <br>
                        <div class="checkbox">
                            <label><input type="checkbox" (click)="toggleCircle()"> Make image circle</label>
                        </div>
                        <input hidden [(ngModel)]="photoFileName" name="photoFileName" class="form-control-static" />
                        <input type="file" accept="image/*" name="_photoFileName" class="form-control" (change)="uploadPhoto($event)" value="" />
                        <small>It's best to use a 1:1 photo. Crop yours before uploading</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="form-group">
            <input [disabled]="f.invalid" data-dismiss="@modal" *ngIf="employee.id == 0" type="submit" value="Add" class="btn btn-primary" (click)="addEmployee()" />
            <input data-dismiss="@modal" *ngIf="employee.id != 0" type="submit" value="Update" class="btn btn-primary" (click)="updateEmployee()" />
        </div>
    </div>
    <code><pre>{{ f.value | json}}</pre></code>
</form>
